import React from 'react'

import { useSelector } from 'react-redux'

import useStyles from './panic-button.style'

import ActionButton from '@components/action-button/action-button.component'
import BodyItem from '@components/body-item/body-item.component'
import CardDropdown from '@components/card-dropdown/card-dropdown.component'
import CardMap from '@components/card-map/card-map.component'
import CarouselContainer from '@components/carousel-container/carousel-container.component'
import ContactActionButton from '@components/contact-button/contact-button.component'
import UpdatedByContainer from '@components/updated-by-container/updated-by-container.component'

import {
  Card,
  Carousel,
  CardBody,
  CardHeader,
  GUN_GRAY,
  Badge,
  Title,
  WHITE
} from '@omnilert/components'
import { PRIORITY_HEADER_PANIC, PRIORITY_BADGE_RESOLVED } from '../../assets/i18n/strings'
import i18n from 'i18n-js'

const PanicButton = (props) => {
  const { message } = props

  const { collection, documentId } = message

  const document = useSelector(({ firestore: { data } }) => data[collection] && data[collection][documentId])

  const {
    actions,
    body,
    contactActions,
    header,
    location,
    meta,
    updatedBy
  } = document

  const actionTaken = meta?.actionTaken

  const isResolved = meta?.isResolved

  const hideActions = isResolved || actionTaken

  const variant = header?.data?.variant

  const titleColor = variant === 'invalid' ? GUN_GRAY : WHITE

  const hasMultipleActions = actions?.length > 1

  const classes = useStyles({ hasMultipleActions })

  if (!document) return null

  return (
    <Card className={classes.card}>
      {header &&
      <CardHeader
        className={classes.cardHeader}
        type={variant}
      >
        <Title
          className={classes.title}
          color={titleColor}
          size='sm'
        >{i18n.t(PRIORITY_HEADER_PANIC)}
        </Title>
        <CardDropdown
          data={header?.data}
          direction='bottom'
        />
      </CardHeader>}

      {location && <CardMap locations={location?.data} />}

      {isResolved && <Badge className={classes.badge}>{i18n.t(PRIORITY_BADGE_RESOLVED)}</Badge>}

      {body && (
        <CardBody className={classes.cardBody}>
          {body.data.map((item, index) => <BodyItem
            key={index}
            item={item}
          />)}
        </CardBody>
      )}

      {updatedBy && <UpdatedByContainer
        data={updatedBy?.data}
        showDivider
      />}

      {(contactActions || actions) && (
        <CarouselContainer>
          {contactActions ? (
            <Carousel className={classes.carousel}>
              {contactActions.data.map((data) => (
                <ContactActionButton
                  key={`contactAction-${data.id}`}
                  data={data}
                  documentId={documentId}
                />
              ))}
            </Carousel>
          ) : null}

          {actions ? (
            <Carousel
              className={classes.scenariosCarousel}
              hideActions={hideActions}
            >
              {actions.data.map(data => (
                <ActionButton
                  key={`action-${data.id}`}
                  data={data}
                  documentId={documentId}
                />
              ))}
            </Carousel>
          ) : null}
        </CarouselContainer>
      )}
    </Card>
  )
}

export default PanicButton
